import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import CertificateList from './List';
import CertificateCreate from './Create';
import CertificateDetail from './Detail';

const defaultFields = {
    Subject : { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    DeleteCertifiedDate: { visible: false, label: '', required: false },
    CertifiedDate: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    Works: { visible: false, label: '', required: false },
    Defects: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    Status: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;
    if (!clauses) {
        if (wfid === 68 && placeholdersQA.PMCertTypes) {
            clauses = placeholdersQA.PMCertTypes.values.filter(item => item.isActive === true);
        }
        else if (wfid === 69 && placeholdersQA.SupplierCertTypes) {
            clauses = placeholdersQA.SupplierCertTypes.values.filter(item => item.isActive === true);
        }
        else if (wfid === 70 && placeholdersQA.ClientCertTypes) {
            clauses = placeholdersQA.ClientCertTypes.values.filter(item => item.isActive === true);
        }
        else if (wfid === 71 && placeholdersQA.SupervisorCertTypes) {
            clauses = placeholdersQA.SupervisorCertTypes.values.filter(item => item.isActive === true);
        }
    }

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Type =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
    fields.Type.clauses = clauses;
    fields.TaskOrder = { visible: !!workflowsQA['38'], label: workflowsQA['38']?.notificationName, required: false };
    fields.ProjectOrder =  { visible: !!workflowsQA['72'], label: workflowsQA['72']?.notificationName, required: false };
    fields.ResetCertifiedDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.RESET_CERTIFIEDDATE"], required: false };

    fields.CertifiedDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.CERTIFIEDDATE"], required: false };
    fields.Description =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: false };
    fields.Works = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.WORKS"], required: false };
    fields.Defects =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DEFECTS"], required: false };

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    const workflowItem = workflowsQA[wfid];

    var replyOptions = workflowItem.replyOptions;
    if (!replyOptions && placeholdersQA.ReplyOptions) {
        replyOptions = placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
    }

    replyFields.Status = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.Status.replyOptions = replyOptions;
    
    return replyFields;
}

class CertificateRouter extends Component {
    constructor(props) {
        super(props);

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;


        if (props.mode === 'PM') {
            this.notificationType = 'PM';
            this.documentType = 'DocumentPmCertificate';
        }
        else if (props.mode === 'SUPPLIER') {
            this.notificationType = 'CON';
            this.documentType = 'DocumentSupplierCertificate';
        }
        else if (props.mode === 'CLIENT') {
            this.notificationType = 'CLI';
            this.documentType = 'DocumentClientCertificate';
        }
        else if (props.mode === 'SUPERVISOR') {
            this.notificationType = 'SUP';
            this.documentType = 'DocumentSupervisorCertificate';
        }
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<CertificateList
                        {...this.props}
                        mode={this.props.mode}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notificationType={this.notificationType}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <CertificateCreate
                                {...this.props}
                                mode={this.props.mode}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<CertificateDetail
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        mode={this.props.mode}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notificationType={this.notificationType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                        contractTemplate={this.props.contractTemplate}
                    />}
                />
            </Routes>
        );
    }
};



export default (CertificateRouter);